import { Box, Tag, TagProps } from '@digibee/beehive-ui';
import {
  CheckCircle,
  QuestionMark,
  Trash,
  WarningTriangle
} from 'iconoir-react';

import * as Elements from './OldStatusDeploy.elements';
import { type Deployment } from '../../scenes/Deployments/components/CardRuntime';
import { useIsAutoscaling } from '../../scenes/Deployments/hooks/useIsAutoscaling';
import { isAutoScalingDeploy } from '../../scenes/Deployments/utils/isAutoScalingDeploy';

import i18n from '~/common/helpers/i18n';
import { IconoirIcon } from '~/common/types/Icon';

type StatusDeployProps = {
  deployment: Deployment;
  disabled?: boolean;
  isMarginBottom?: boolean;
  isMinHeight?: boolean;
  isPipelineEngine?: boolean;
};

export type DataMessageType = {
  loader?: boolean;
  text: string;
  icon: IconoirIcon;
  style: string;
};

export const getMessageStatus = (deployment: Deployment): DataMessageType => {
  const status: { [key: string]: DataMessageType } = {
    deleting: {
      text: i18n.t('label.deleting'),
      icon: Trash,
      style: 'warning'
    },
    starting: {
      text: i18n.t('label.starting'),
      icon: QuestionMark,
      loader: true,
      style: 'neutral'
    },
    degraded: {
      text: i18n.t('label.starting'),
      icon: QuestionMark,
      style: 'info'
    },
    error: {
      text: i18n.t('label.error'),
      style: 'danger',
      icon: WarningTriangle
    },
    deployed: {
      text: i18n.t('label.deployed'),
      style: 'success',
      icon: CheckCircle
    },
    rollbacked: {
      text: i18n.t('label.rolled_back'),
      icon: QuestionMark,
      style: 'info'
    },
    restored: {
      text: i18n.t('label.restored_colon'),
      icon: CheckCircle,
      style: 'success'
    }
  };

  const statusSelected: string = deployment?.status?.text?.toLowerCase();
  if (status[statusSelected]) {
    return status[statusSelected];
  }
  return status.deployed;
};

export const StatusDeploy = ({
  deployment,
  isMarginBottom = true,
  isMinHeight = true
}: StatusDeployProps) => {
  const dataMessage: DataMessageType = getMessageStatus(deployment);
  const showNewAutoScalingExperience = useIsAutoscaling();
  const showAutoScalingValues =
    isAutoScalingDeploy({
      minReplicaCount: deployment.activeConfiguration?.minReplicaCount,
      replicaCount: deployment.activeConfiguration?.replicaCount
    }) && showNewAutoScalingExperience;

  return (
    <Elements.ContainerStatus
      isMarginBottom={isMarginBottom}
      isMinHeight={isMinHeight}
    >
      <Tag variant={dataMessage.style as TagProps['variant']}>
        {dataMessage.text}
      </Tag>
      {showAutoScalingValues && (
        <Box css={{ marginLeft: '$3' }}>
          <Tag variant='info'>Autoscaling</Tag>
        </Box>
      )}
    </Elements.ContainerStatus>
  );
};
